import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ContentPromptsPage = lazy(() => import('~/features/content/pages/content-prompts-page'));

/** AI instructions (formerly Prompts) at `/content/settings/instructions`. */
export const Route = createFileRoute('/_authenticated/_tenant/content/settings/instructions')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ContentPromptsPage />
    </Suspense>
  ),
});
